(ns frontend.ui.component.lp-portal.stacked-text-group.pdf.view
  (:require
   [clojure.string :as s]
   [frontend.ui.style.theme.core :as theme]))

(defn stack-label
  [label-text]
  {:text     (s/upper-case label-text)
   :bold     true
   :fontSize 7
   :color    (theme/color [:pdf :stack :label])
   :margin   [0 4 0 0]})

(defn stack-value
  [value-text]
  {:text     (str value-text)
   :fontSize 7
   :color    (theme/color [:pdf :stack :value])})

(defn stacked-text-group
  [label value]
  [(stack-label label)
   (stack-value value)])
